import { Form, Select, Input } from 'antd';
import FloatingLabel from '../../../../components/FloatingLabel/FloatingLabel';
import StateSeeder from '../../../../components/StateSeeder/StateSeeder';
import { ChevronDown, ChevronUp } from '../../../../assets/icons';
import { cityRegex, zipCodeRegex, ResidentialAddressRegex, addressPOBoxRegex } from '../../../../utils/Validations';

// Shared field set for the personal-address and entity-address edit modals (EditAddress.js /
// EditEntityAddress.js) — the two forms are otherwise identical aside from labels, the submit
// payload shape, and how the initial state/stateId gets resolved, which stay in each modal.
const AddressFields = ({
  addressLabel,
  addressRequiredMessage,
  addressInvalidMessage,
  addressLengthMessage,
  aptNumberInvalidMessage,
  countryAnchorId,
  address,
  setAddress,
  aptNumber,
  setAptNumber,
  city,
  setCity,
  state,
  setState,
  setStateName,
  zipCode,
  setZipCode,
  country,
  setCountry,
  isEdit,
  arrowUp,
  setArrowUp,
}) => (
  <>
    <FloatingLabel label={addressLabel} inputId='address' inputValue={address} isEdit={isEdit}>
      <Form.Item
        validateTrigger='onBlur'
        name='address'
        rules={[
          {
            required: true,
            message: addressRequiredMessage,
            pattern: ResidentialAddressRegex,
          },
          {
            message: addressInvalidMessage,
            pattern: addressPOBoxRegex,
          },
          {
            min: 2,
            max: 49,
            message: addressLengthMessage,
          },
        ]}
      >
        <Input id='address' value={address} onChange={(e) => setAddress(e.target.value)} />
      </Form.Item>
    </FloatingLabel>
    <FloatingLabel label='C/O, Apt, Suite, Unit' inputId='aptNumber' inputValue={aptNumber} isEdit={isEdit}>
      <Form.Item
        validateTrigger='onBlur'
        name='aptNumber'
        rules={[
          {
            min: 1,
            max: 32,
            message: 'Please provide a valid apartment number value. Apartment number length should be between 1 and 32.',
          },
          {
            message: aptNumberInvalidMessage,
            pattern: addressPOBoxRegex,
          },
        ]}
      >
        <Input id='aptNumber' value={aptNumber} onChange={(e) => setAptNumber(e.target.value)} />
      </Form.Item>
    </FloatingLabel>
    <FloatingLabel label='City' inputId='city' inputValue={city} isEdit={isEdit}>
      <Form.Item
        validateTrigger='onBlur'
        name='city'
        rules={[
          {
            required: true,
            message: 'Enter a valid City.',
            pattern: new RegExp(cityRegex),
          },
          {
            min: 2,
            max: 35,
            message: 'Please provide a valid city value. City length should be between 2 and 35.',
          },
        ]}
      >
        <Input id='city' value={city} onChange={(e) => setCity(e.target.value)} />
      </Form.Item>
    </FloatingLabel>
    {isEdit && (
      <StateSeeder value={state} setState={(value) => setState(value)} setStateName={setStateName} isEdit={isEdit} required={true} />
    )}
    <FloatingLabel label='Zip Code' inputId='zipcode' inputValue={zipCode} isEdit={isEdit}>
      <Form.Item
        validateTrigger='onBlur'
        name='zipcode'
        rules={[
          {
            required: true,
            message: 'Please enter a valid zip code.',
            pattern: zipCodeRegex,
          },
        ]}
      >
        <Input
          type='number'
          id='zipcode'
          value={zipCode}
          onChange={(e) => setZipCode(e.target.value)}
          onKeyPress={(event) => {
            if (!/\d/.test(event.key)) {
              event.preventDefault();
            }
          }}
        />
      </Form.Item>
    </FloatingLabel>
    <FloatingLabel label='Country' inputId='country' inputValue={country} isEdit={isEdit}>
      <>
        <div id={countryAnchorId} />
        <Form.Item className='mb-48'>
          <Select
            id='country'
            onChange={(value) => setCountry(value)}
            value={country}
            getPopupContainer={() => document.getElementById(countryAnchorId)}
            onDropdownVisibleChange={() => setArrowUp(!arrowUp)}
            suffixIcon={arrowUp ? <ChevronUp color='#1A1519' /> : <ChevronDown color='#1A1519' />}
            disabled
          >
            <Select.Option value='unitedstates'>United States</Select.Option>
          </Select>
        </Form.Item>
      </>
    </FloatingLabel>
  </>
);

export default AddressFields;
